import { Button } from "@material-ui/core";
import React from "react";
import { useAccount, useConnect, useDisconnect } from "wagmi";
import { InjectedConnector } from "wagmi/connectors/injected";

export default function WagmiConnect() {
  const { address, isConnected } = useAccount();
  const { connect } = useConnect({
    connector: new InjectedConnector(),
  });
  const { disconnect } = useDisconnect();
  return (
    <>
      {!isConnected && (
        <Button onClick={connect} variant="contained" color="primary">
          Connect Wallet
        </Button>
      )}

      {isConnected && (
        <div>
          <p>Connected as {address}</p>
          <Button onClick={disconnect} variant="contained" color="primary">
            Disconnect Wallet
          </Button>
        </div>
      )}
    </>
  );
}
